import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'minus', 'Minus', [["path",{"d":"M5 12l14 0","key":"svg-0"}]]);